export const GET_JOBS_APPLICATIONS_URL = `/recruitment/apply`;
